import { useMutation } from "@apollo/client/react";
import { useTeam } from "@hooks";
import moment from "moment";
import { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router";

import { formToNoteInput } from "./common/utils";
import {
  CREATE_PATIENT_NOTE,
  CREATE_QUICK_NOTE,
} from "./edit/api/mutations";
import { submitBasicNote } from "./edit/api/submit";

function CreateNote() {
  const { patientUUID } = useParams();
  const navigate = useNavigate();

  const [createPatientNote] = useMutation(CREATE_PATIENT_NOTE);
  const [createQuickNote] = useMutation(CREATE_QUICK_NOTE);

  const { currentTeam } = useTeam();
  const hasCreatedNoteRef = useRef(false);
  const teamUUID = currentTeam?.uuid || null;

  useEffect(() => {
    if (hasCreatedNoteRef.current) {
      return;
    }
    hasCreatedNoteRef.current = true;

    const submitAsync = async () => {
      const structuredNoteData = formToNoteInput({
        data: {
          createdAt: moment().format(),
        },
        isNewNote: true,
      });

      const { submittedNoteUuid } = await submitBasicNote({
        structuredNoteData,
        mutations: { createPatientNote, createQuickNote },
        props: {
          patientUUID: patientUUID || null,
          teamUUID,
        },
        isDraft: true,
        isAutosave: true,
      });

      navigate(`/edit_note/${submittedNoteUuid}`, { replace: true });
    };

    void submitAsync();
  }, [
    createPatientNote,
    createQuickNote,
    navigate,
    patientUUID,
    teamUUID,
  ]);

  return null;
}

export default CreateNote;
